module.exports = __webpack_public_path__ + "img/Try Giv2 Demo.d259d145.png";